import { useNavigate, useRouteError } from 'react-router-dom';
import React, { useCallback } from 'react';

import { ErrorView } from '../../components/error-view';
import { useDeviceType } from '../../hooks';
import { ForbiddenBody } from '../forbidden';

export const Error = (): React.ReactElement => {
  const error = useRouteError();
  const deviceType = useDeviceType();
  const navigate = useNavigate();

  const onReturnToStartPagePress = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const onReloadPagePress = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <ErrorView
      error={error}
      isMobile={deviceType === 'mobile'}
      onReturnHome={onReturnToStartPagePress}
      onReload={onReloadPagePress}
      forbiddenBody={<ForbiddenBody />}
    />
  );
};
